import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceThcClearanceModel } from './types';
import substanceThcClearanceItemValidator from './validators/item';

const substanceThcClearanceValidator: ValidateJSModel<SubstanceThcClearanceModel> = {
  UsedThc: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedThc && attributes?.UsedThc.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: substanceThcClearanceItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceThcClearanceValidator;
